// extracted by mini-css-extract-plugin
export default {"ModalTitle":"jaPCQN_q"};